'use client';

import { useOwner } from '../../context/OwnerProvider';
import { Ratings } from '@/components/shared/Ratings';

export function OwnerRatings() {
  const { ownerRatings, isMasked } = useOwner();

  // Always show the section, even if ratings are null (will show masked state)
  return <Ratings ratings={ownerRatings} isMasked={isMasked} title="Building ratings" />;
}
